import { InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className = '',
  label,
  error,
  id,
  ...props
}, ref) => {
  const inputId = id || Array.from({length:8}, () => Math.random().toString(36)[2]).join('');

  return (
    <div className="flex flex-col gap-1.5 w-full">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium tracking-wide uppercase text-on-surface-variant">
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        className={`w-full bg-surface-container-high text-on-surface placeholder-on-surface-variant/50 px-4 py-2.5 rounded 
          focus:outline-none focus:ring-1 focus:ring-primary focus:shadow-[0_0_8px_rgba(180,197,255,0.2)] transition-shadow
          ${error ? 'bg-error-container/10 border-error text-error' : 'border border-transparent'}
          ${className}`}
        {...props}
      />
      {error && <span className="text-xs text-error mt-0.5">{error}</span>}
    </div>
  );
});

Input.displayName = 'Input';
